import { useState } from 'react'
import { usePostHog } from '@posthog/react'
import * as PopoverPrimitive from '@radix-ui/react-popover'
import { MessageSquarePlus, X, Send, CheckCircle } from 'lucide-react'
import styles from './FeedbackWidget.module.scss'

export function FeedbackWidget() {
  const posthog = usePostHog()
  const [open, setOpen] = useState(false)
  const [comment, setComment] = useState('')
  const [submitted, setSubmitted] = useState(false)

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    const trimmed = comment.trim()
    if (!trimmed) return

    if (posthog) {
      posthog.capture('user_feedback', {
        comment: trimmed,
        page: window.location.pathname,
      })
    }

    setSubmitted(true)
    setTimeout(() => {
      setOpen(false)
    }, 1800)
  }

  function handleOpenChange(next: boolean) {
    if (!next) {
      setComment('')
      setSubmitted(false)
    }
    setOpen(next)
  }

  return (
    <PopoverPrimitive.Root open={open} onOpenChange={handleOpenChange}>
      <PopoverPrimitive.Trigger asChild>
        <button
          type="button"
          aria-label="Invia feedback"
          className={styles.fab}
          data-open={open || undefined}
        >
          <MessageSquarePlus size={18} aria-hidden />
        </button>
      </PopoverPrimitive.Trigger>

      <PopoverPrimitive.Portal>
        <PopoverPrimitive.Content
          side="top"
          align="end"
          sideOffset={12}
          className={styles.panel}
        >
          {submitted ? (
            <div className={styles.thanks}>
              <CheckCircle size={20} className={styles.thanksIcon} aria-hidden />
              <span>Grazie per il feedback!</span>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className={styles.header}>
                <h2 className={styles.title}>Open feedback</h2>
                <PopoverPrimitive.Close className={styles.closeBtn} aria-label="Chiudi">
                  <X size={16} aria-hidden />
                </PopoverPrimitive.Close>
              </div>

              <textarea
                className={styles.textarea}
                placeholder="Cosa non funziona? Cosa vorresti fare? Come lo faresti?"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                rows={4}
                // eslint-disable-next-line jsx-a11y/no-autofocus
                autoFocus
              />

              <div className={styles.footer}>
                <button
                  type="submit"
                  disabled={!comment.trim()}
                  className={styles.submitBtn}
                >
                  <Send size={13} aria-hidden />
                  Invia
                </button>
              </div>
            </form>
          )}
        </PopoverPrimitive.Content>
      </PopoverPrimitive.Portal>
    </PopoverPrimitive.Root>
  )
}
